module.exports = __webpack_public_path__ + "static/media/axe.f3cb82a4.svg";